/* global google */
import React from 'react';
import ReactDOMServer from 'react-dom/server';
import markerImage from 'img/marker-red.png';
import userMarkerImage from 'img/pin-red.png';
import { translateKey } from '_translations';

export function getMapOptions() {
  if (window.google.length === 0) {
    return null;
  }

  return {
    zoom: 7,
    center: new google.maps.LatLng(55.3781, 3.4360),
    mapTypeControl: false,
    disableDefaultUI: true,
  };
}

export function getMarkerIcon() {
  if (window.google.length === 0) {
    return null;
  }

  return {
    url: markerImage,
    size: new google.maps.Size(32, 53),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(16, 26),
  };
}

export function getUserMarker() {
  if (window.google.length === 0) {
    return null;
  }

  return {
    url: userMarkerImage,
    size: new google.maps.Size(46, 69),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(16, 26),
  };
}

export function mapDataToMarkers(data) {
  return data.map(x => ({
    lat: x.latitude,
    lng: x.longitude,
    info: getInfoHtml(x),
  }));
}

function getInfoHtml(location) {
  const jsx = (
    <div className="info-window">
      <div className="info-window__title">
        {location.eventName}
        <br/>
        <br/>
      </div>
      <div className="info-window__location">
        {location.locationName}
      </div>
      <div className="info-window__details">
        {location.startDate &&
          (
            <div><span className="prefix">{translateKey('Pitstop.Map.From')}</span> {location.startDate.localisedDate}</div>
          )
        }
        <br/>
        {location.endDate &&
          (
            <div><span className="prefix">{translateKey('Pitstop.Map.To')}</span> {location.endDate.localisedDate}</div>
          )
        }
        <br/>
        <br/>
        {location.stand.length > 0 &&
          (
            <div><span className="prefix">{translateKey('Pitstop.Map.Stand')}</span> {location.stand}</div>
          )
        }
      </div>
    </div>
  );

  return ReactDOMServer.renderToStaticMarkup(jsx);
}
